/**
 * MacroBaby — Comportamentos diversos da UI:
 *  - "See more" do menu mobile
 *  - Hover do nav-bar dropdown (.item-custom)
 *
 * Depende de: jQuery
 */

/**
 * Swiper — promove data-src/data-srcset -> src/srcset apenas para os slides
 * atualmente visíveis, para que o navegador não baixe imagens de páginas do
 * slider que o usuário ainda não navegou até. Chamar em on: { init, slideChange, breakpoint }.
 */
window.mbLoadVisibleSwiperImages = function (swiper) {
    if (!swiper || !swiper.visibleSlides) return;
    swiper.visibleSlides.forEach(function (slide) {
        slide.querySelectorAll('source[data-srcset]').forEach(function (source) {
            source.srcset = source.getAttribute('data-srcset');
            source.removeAttribute('data-srcset');
        });
        slide.querySelectorAll('img[data-src]').forEach(function (img) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
            if (img.dataset.srcset) {
                img.srcset = img.dataset.srcset;
                img.removeAttribute('data-srcset');
            }
        });
    });
};

/**
 * Fronteira de carregamento lento (section "lazy-render-boundary") — sections
 * que vêm depois dela na ordem do documento só rodam sua inicialização JS
 * (initFn) quando chegarem perto da tela, em vez de todas de uma vez no load.
 * Sections acima da fronteira (ou se ela não existir na página) inicializam
 * imediatamente, como sempre.
 */
window.mbDeferIfBelowLazyBoundary = function (sectionRootEl, initFn, options) {
    if (!sectionRootEl || typeof initFn !== 'function') return;

    var boundary = document.querySelector('.mb-lazy-boundary');
    var isBelowBoundary = boundary &&
        !!(boundary.compareDocumentPosition(sectionRootEl) & Node.DOCUMENT_POSITION_FOLLOWING);

    if (!isBelowBoundary) {
        initFn();
        return;
    }

    var opts = options || {};
    var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                obs.disconnect();
                initFn();
            }
        });
    }, { rootMargin: opts.rootMargin || '300px 0px' });

    observer.observe(sectionRootEl);
};

(function ($) {
    $(document).ready(function () {
        // Toggle do botão "see more" do menu mobile
        $(".see-more-btn-mm").on("click", function () {
            $(this).toggleClass("ativo");
        });

        // Hover do nav dropdown
        $(".item-custom").on("mouseover", function () {
            $(this).addClass("active");
            $(this).closest(".nav-bar__linklist").addClass("nav-dropdown--glued");
            $(this).find(".nav-dropdown").attr("aria-hidden", "false");
        }).on("mouseleave", function () {
            $(this).removeClass("active");
            $(this).removeClass("is-dropdown-open");
            $(this).closest(".nav-bar__linklist").removeClass("nav-dropdown--glued");
            $(this).find(".nav-dropdown").attr("aria-hidden", "true");
            $(this).find(".nav-bar__link").attr("aria-expanded", "false");
        });

        function syncFilledFieldState(field) {
            field.classList.toggle("is-filled", field.value !== "");
        }

        function syncAllFilledFieldStates() {
            document.querySelectorAll(".form__field").forEach(syncFilledFieldState);
        }

        document.addEventListener("input", function (event) {
            if (event.target.matches(".form__field")) {
                syncFilledFieldState(event.target);
            }
        });

        document.addEventListener("change", function (event) {
            if (event.target.matches(".form__field")) {
                syncFilledFieldState(event.target);
            }
        });

        document.addEventListener("blur", function (event) {
            if (event.target.matches(".form__field")) {
                syncFilledFieldState(event.target);
            }
        }, true);

        window.addEventListener("pageshow", syncAllFilledFieldStates);
        setTimeout(syncAllFilledFieldStates, 300);
        setTimeout(syncAllFilledFieldStates, 1000);

        // Expandable content (collection description "View more / View less")
     function processCollapsibles() {
  document.querySelectorAll('.expandable-content').forEach(function (item) {
    if (item.scrollHeight > item.clientHeight) {
      item.classList.add('expandable-content--expandable');
    } else {
      item.classList.remove('expandable-content--expandable');
    }
  });
}

document.addEventListener('click', function (e) {
  var btn = e.target.closest('.expandable-content__toggle');

  if (!btn) return;

  var container = btn.closest('.expandable-content');

  if (!container) return;

  var isExpanded = btn.getAttribute('aria-expanded') === 'true';

  if (isExpanded) {
    btn.setAttribute('aria-expanded', 'false');
    container.classList.remove('expandable-content--expanded');
  } else {
    btn.setAttribute('aria-expanded', 'true');
    container.classList.add('expandable-content--expanded');
  }

  var text = btn.querySelector('.expandable-content__toggle-text');

  if (text) {
    text.textContent = isExpanded
      ? text.getAttribute('data-view-more')
      : text.getAttribute('data-view-less');
  }
});
        document.addEventListener('shopify:section:load', processCollapsibles);
        processCollapsibles();

        // Botão "See more" do menu mobile que expande a lista de serviços
        const servicesList = window.servicesListMobile;
        if (servicesList) {
            const expandBtn = document.createElement("button");
            expandBtn.innerText = "See more";
            expandBtn.classList.add("botaoExpand");
            expandBtn.addEventListener("click", function (e) {
                const btn = e.currentTarget;
                const expanded = servicesList.classList.contains("expanded");
                const panel = document.querySelector(".mobile-menu__panel");
                if (expanded) {
                    const scrollY = parseInt(btn.dataset.currentScroll);
                    btn.innerText = "See more";
                    panel.scrollTo({ top: scrollY, behavior: "smooth" });
                    servicesList.classList.remove("expanded");
                } else {
                    btn.innerText = "See less";
                    btn.dataset.currentScroll = panel.scrollTop;
                    servicesList.classList.add("expanded");
                }
            });
            servicesList.after(expandBtn);
        }
    });
})(jQuery);
